import styled from 'styled-components';
import theme from 'styles/theme';

export const SectionWrapper = styled.section`
  margin-bottom: 25px;
  padding: 15px 20px 25px;
  font-size: 13px;
  line-height: 23px;
  background-color: #f5f5f5;
  border-radius: 5px;
  text-align: right;

  .title {
    img {
      margin-right: 4px;
      width: 13px;
      height: 13px;
    }
  }

  .description {
    margin-bottom: 15px;
  }

  div {
    padding: 15px 18px 10px;
    background-color: #fff;
    border-radius: 5px;

    dl {
      margin-bottom: 7px;
      display: flex;
      font-size: 12px;
      line-height: 17px;

      dt {
        font-weight: 700;
        min-width: 57px;

        &.FAIL,
        &.NOT_LINKED {
          color: #fc5555;
        }

        &.STOP {
          color: #ff5608;
        }

        &.WAIT {
          color: #29cc6a;
        }

        &.FINISH {
          color: ${theme.color.aizenBlue};
        }
      }
    }
  }

  button {
    margin: 10px 0 -5px;
    padding: 0 18px;
    height: 34px;
    font-size: 13px;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #dcdce4;
  }
`;
